var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.902,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.868 16.316a1.245 1.245 0 0 1 1.669.56 9.963 9.963 0 1 0 0-8.842 1.253 1.253 0 1 1-2.242-1.121 12.454 12.454 0 1 1 0 11.088 1.245 1.245 0 0 1 .573-1.681Zm-.623-5.106h11.943l-2.864-2.852a1.252 1.252 0 0 1 1.771-1.769l4.981 4.982a1.287 1.287 0 0 1 0 1.768l-4.981 4.982a1.25 1.25 0 1 1-1.768-1.768l2.861-2.852H1.245a1.246 1.246 0 0 1 0-2.491Z"
  })));
};
export default SvgLogoutIcon;